<template>
  <v-dialog :value="value" v-on="$listeners" scrollable lazy max-width="600px">
    <v-card>
      <v-card-text class="content">
        <v-data-table :items="qualities" hide-headers hide-actions :total-items="-1">
          <template #items="{ item }">
            <td v-html="item.key"></td>
            <td v-if="item.video" class="pb-1 pt-1">
              <v-chip
                v-if="item.state === 'done' || item.state === 'error' "
                :color="item.color"
                :disabled="true"
                text-color="white"
              >{{ item.value }}
              </v-chip>
              <v-progress-circular
                v-else
                :indeterminate="item.state === 'pending'||item.percentage === 0"
                color="primary"
                :value="item.percentage"
                size="50"
                width="6"
              >{{ item.percentage }}
              </v-progress-circular>
            </td>
            <td v-else v-html="item.value"></td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-layout row justify-end>
          <v-btn
            @click="fetchVideoTranscodingState"
            :loading="fetchingVideoTranscodingState"
            color="secondary"
            flat
          >{{ $t(`message.transcoding.retryCheckState`) }}
          </v-btn>
          <v-btn
            color="secondary"
            flat
            @click.native="closeDialog"
          >{{ $t('message.common.close') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/modules/content/editor/api';

export default {
  name: 'nx-entity-metadata-transcoding-state-dialog',
  props: {
    id: Number,
    type: String,
    value: Boolean,
  },
  data() {
    return {
      fetchingVideoTranscodingState: false,
      qualities: [],
      fetchInterval: null,
    };
  },
  methods: {
    videoTranscodingState(qualities) {
      return qualities.map(({ type, state, percent }) => {
        const colors = {
          done: 'green',
          working: 'blue lighten-3',
          pending: 'amber lighten-3',
          error: 'red',
        };
        return {
          video: true,
          key: this.$t(`message.transcoding.type.${type}`),
          value: this.$t(`message.transcoding.state.${state}`),
          color: colors[state],
          state,
          percentage: percent,
        };
      });
    },
    async fetchVideoTranscodingState() {
      const FETCH_INTERVAL = 1000 * 10;
      this.fetchingVideoTranscodingState = true;
      const result = await api.fetchVideoTranscodingState(this.id, this.type);
      console.info(result);
      this.qualities = this.videoTranscodingState(result.qualities);
      this.fetchingVideoTranscodingState = false;
      if (!this.fetchInterval) {
        this.fetchInterval = setInterval(() => {
          api.fetchVideoTranscodingState(this.id, this.type).then((res) => {
            this.qualities = this.videoTranscodingState(result.qualities);
          });
        }, FETCH_INTERVAL);
      }
    },
    closeDialog() {
      clearInterval(this.fetchInterval);
      this.fetchInterval = null;
      this.$emit('input', false);
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.fetchVideoTranscodingState();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.content {
  min-height: 200px;
}
.align-end {
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
}
</style>
